import type { IVirtualClassroomRepository } from './interfaces/IVirtualClassroomRepository'
import type { VirtualClassroom } from '@/types'
import { getDocument } from '@/services/firestore'

export class FirestoreVirtualClassroomRepository implements IVirtualClassroomRepository {
  async getById(id: string): Promise<VirtualClassroom | null> {
    return getDocument<VirtualClassroom>('virtual_classrooms', id)
  }

  async getByIds(ids: string[]): Promise<VirtualClassroom[]> {
    const results: VirtualClassroom[] = []
    // Firestore 'in' query limited to 30, batch in groups of 30
    for (let i = 0; i < ids.length; i += 30) {
      const batch = ids.slice(i, i + 30)
      const promises = batch.map((id) => this.getById(id))
      const docs = await Promise.all(promises)
      for (const doc of docs) {
        if (doc) results.push(doc)
      }
    }
    return results
  }
}
